<template src="./html/Create.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Slug from './Slug'
	export default {
		props: ['user', 'isAuth'],
		components: {
			'slug': Slug,
		},
		data () {
			return {
				modal: {
					selector: 'category-create',
				},

				languages: null,
				statuses: null,
				roles: null,

				item: {
					title: null,
					slug: null,
					role_id: null,
					lang_id: null,
					status_id: null,
				},
				loading: false,
				slug_in_use: false,
			}
		},
		mounted() {
			var modal = $('#'+this.modal.selector)
			var that = this
			modal.on('hidden.bs.modal', function () {
				that.clearData()
			})
		},
		watch: {
			'item.title'() {
				this.item.slug = this.$options.filters.slugify(this.item.title)
			},
		},
		methods: {
			open() {
				this.clearData()
				this.init()
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			init() {
				this.getStatuses()
				this.getLanguages()
				this.getRoles()
			},
			clearData() {
				this.item.title = null
				this.item.slug = null
				this.item.role_id = 8
				this.item.lang_id = null
				this.item.status_id = 2
				this.loadDefaultLanguage()
				this.errors.clear()
			},
			getStatuses: function() {
				this.statuses = null
				this.$http.get('admin/statuses')
					.then(response => {
						this.statuses = response.body
						this.item.status_id = 2
					})
			},
			getLanguages: function() {
				this.languages = null
				this.$http.get('languages')
					.then(response => {
						this.languages = response.body
						this.loadDefaultLanguage()
					})
			},
			loadDefaultLanguage() {
				if(this.languages) {
					if(this.languages.length) {
						var locale = this.$lang.getLang()
						var lang = this.languages.find(function(language) {
							return language.lang_code == locale
						})
						if(lang) {
							this.item.lang_id = lang.id
						}
					}
				}
			},
			getRoles: function() {
				this.roles = null
				this.$http.get('admin/roles')
					.then(response => {
						this.roles = response.body
						this.item.role_id = 8
					})
			},
			slugInUse(slug_in_use) {
				this.slug_in_use = slug_in_use
			},
			changeLoading(loading) {
				this.loading = loading
			},
			validate() {
				var that = this
				if(this.slug_in_use) {
					return false
				}
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.store()
					}
					if(that.$validator.errors.items.length) {
						that.$el.querySelector('[name=' + that.$validator.errors.items[0].field + ']').focus()
					}
					return result
				})
			},
			store () {
				if(!this.loading) {
					if(!this.slug_in_use) {
						var btnStore = Ladda.create(this.$refs.btnStore)
						btnStore.start()
						this.$http.post('admin/cms/categories', this.item)
						.then(response => {
							this.close()
							this.$emit('reload')
							btnStore.stop()
							swal({
								title: response.body.title,
								text: response.body.text,
								type: response.body.type,
							})
							this.editOrContinue(response)
						}).catch(function(response) {
							console.log(response)
							this.$emit('reload')
							btnStore.stop()
							if(response.status == 409) {
								swal({
									title: response.body.title,
									text: response.body.text,
									type: response.body.type,
								})
							}
						})
					}
				}
			},
			editOrContinue(response) {
				var category = response.body.data
				var that = this
				swal({
					title: response.body.title,
					text: response.body.text,
					type: response.body.type,
					showCancelButton: true,
					confirmButtonColor: '#2cabe3',
					confirmButtonText: 'Editar',
					cancelButtonText: 'Continuar',
				}).then(function () {
					that.$router.push('/' + that.$i18n.locale + '/' + that.$platform.slug + "/admin/cms/categories/" + category.id + '/edit')
				}).catch(swal.noop)
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/cms/categories/views/Create.vue